import { useSteps } from "react-step-builder";
import { useMasterForm, useUpdateDatabase } from "src/hooks";
import { useDoc } from "src/hooks/databaseHooks";
import { useCreateSteps } from "../validation/getSteps";
import { useSelector } from "react-redux";
import { selectTrack } from "src/store/projectSelectors";

const useUserEsgSurvey = ({ surveyAreas, respondentId }) => {

  const { createGetStepsFn } = useCreateSteps()

  const surveyPath = ["esg-survey", respondentId, "entries", "self"]

  const { status, data: dataDB } = useDoc(surveyPath);

  const track = useSelector(selectTrack)

  const getSteps = createGetStepsFn(surveyAreas, track)

  const masterFormMethods = useMasterForm({
    pathArr: surveyPath,
    dataDB,
    canAdvanceEmpty: false,
    getFieldsObject: (getValues) => getSteps?.(getValues) || [],
  });

  const { prev, current, next, hasNext } = useSteps();

  const { updateDocument } = useUpdateDatabase();

  const { formMethods, onFormSubmit } = masterFormMethods || {};
  const { getValues } = formMethods || {};

  const onNext = async (e) => {
    const noErrors = await onFormSubmit(e);
    if (noErrors && hasNext) {
      const highest = getValues("highest-completed");

      if ((highest || 0) < current) {
        updateDocument(["esg-survey", respondentId, "entries", "self"], {
          "highest-completed": current,
        });

      }
      next(e);
    }
  };



  return {
    ...masterFormMethods,
    nextClickHandler: onNext,
    prevClickHandler: prev,
    status,
  };
};

export default useUserEsgSurvey;
